import { render, staticRenderFns } from "./choose-knowledgePoints.vue?vue&type=template&id=5f4dae70&scoped=true"
import script from "./choose-knowledgePoints.vue?vue&type=script&lang=js"
export * from "./choose-knowledgePoints.vue?vue&type=script&lang=js"
import style0 from "./choose-knowledgePoints.vue?vue&type=style&index=0&id=5f4dae70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4dae70",
  null
  
)

export default component.exports